module.exports = __webpack_public_path__ + "img/ninja-paintbrushes.7eb09bc9.svg";